import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../../../InputField';
import FormError from '../../../FormError';
import SelectField from 'components/SelectField';
// import SelectWithInputField from '../../../SelectWithInputField';
// import { REFERENCE_OPTIONS } from 'constants/users';
import { hasComma, isNotEmail } from 'helpers/validators';

import styles from './styles.module.scss';

let EditUserForm = ({
  handleSubmit,
  user,
  showEmail,
  showAclGroup,
  userTypes,
  error,
  isResellerGroup,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className={styles.row}>
          <div className={styles.leftHalf}>
            {showEmail ? (
              <Field component={InputField} name="email" label="Email*" />
            ) : (
              <Field
                component={InputField}
                name="email"
                label="Email*"
                input={{ value: user.email }}
                disabled={true}
                readOnly={true}
              />
            )}
          </div>
          <div className={styles.rightHalf}>
            <Field
              component={InputField}
              name="phone_number"
              label="Phone Number"
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.leftHalf}>
            <Field
              component={InputField}
              name="first_name"
              label="First Name*"
            />
          </div>
          <div className={styles.rightHalf}>
            <Field component={InputField} name="last_name" label="Last Name*" />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.leftHalf}>
            <Field
              component={InputField}
              name="company_name"
              label="Company Name"
            />
          </div>
          {isResellerGroup ? (
            showAclGroup ? (
              <div className={styles.rightHalf}>
                <Field
                  component={SelectField}
                  options={userTypes}
                  name="acl_group_name"
                  label="Acl Group Name*"
                />
              </div>
            ) : (
              <div className={styles.rightHalf}></div>
            )
          ) : (
            <div className={styles.rightHalf}>
              <Field
                component={InputField}
                name="reference"
                label="Reference"
              />
              {/* <Field component={SelectWithInputField} name="reference" label="Reference" options={REFERENCE_OPTIONS} /> */}
            </div>
          )}
        </div>
        {!isResellerGroup && showAclGroup && (
          <div className={styles.row}>
            <div className={styles.leftHalf}>
              <Field
                component={SelectField}
                options={userTypes}
                name="acl_group_name"
                label="Acl Group Name*"
              />
            </div>
            <div className={styles.rightHalf}></div>
          </div>
        )}
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-primary">Save User Details</button>
      </form>
    </div>
  );
};

const validate = (values, { showEmail, showAclGroup }) => {
  let errors = {};
  if (showEmail && !values.email) {
    errors.email = 'Required';
  } else if (showEmail && isNotEmail(values.email)) {
    errors.email = 'Invalid email';
  }
  if (!values.first_name) {
    errors.first_name = 'Required';
  } else if (hasComma(values.first_name)) {
    errors.first_name = 'Comma sign is not allowed';
  }

  if (!values.last_name) {
    errors.last_name = 'Required';
  } else if (hasComma(values.last_name)) {
    errors.last_name = 'Comma sign is not allowed';
  }

  if (values.company_name && hasComma(values.company_name)) {
    errors.company_name = 'Comma sign is not allowed';
  }
  if (showAclGroup && !values.acl_group_name) {
    errors.acl_group_name = 'Required';
  }
  return errors;
};

EditUserForm = reduxForm({
  form: 'user',
  validate,
})(EditUserForm);

export default EditUserForm;
